<template>
  <div class="error404">
    <div class="center">
      <h1>Are you lost ?</h1>
    </div>
    <router-link :to="{ path: '/' }">
      <button class="shard-button">Go back home</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'error-404',
  components: {
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

h1 {
  font-size: 48px;
  letter-spacing: 20px;
  font-weight: 700;
  line-height: 1.5;
  text-transform: uppercase;
  text-align: center;
  transition: all .3s ease;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, .5);
  opacity: 0;
  transform: scale(.7);
  animation: appear 1s ease 1s forwards;

  @media screen and (max-width: 640px) {
    font-size: 24px;
    letter-spacing: 15px;
  }

  @keyframes appear {
    0% {
      opacity: 0;
      transform: scale(.7);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
}

.shard-button {
  position: fixed;
  top: calc(50% + 70px);
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/error404.vue